import { Outlet } from "react-router-dom"

import ClientPageHeader from "./ClientPageHeader"
import useSetCurrentSBChannel from "./hooks/useSetCurrentSBChannel"
import ScheduledMessageModal from "./routines/ScheduledMessageModal"
import SessionBookingModal from "./sessions/SessionBookingModal"
import SessionLateCancelModal from "./sessions/SessionLateCancelModal"
import SessionMakeupVerificationModal from "./sessions/SessionMakeupVerificationModal"
import SessionNoShowModal from "./sessions/SessionNoShowModal"
import TOSNotSignedHeader from "./TOSNotSignedHeader"
import { useSendbird } from "../../components/sendbird/SBProvider"
import useMobile from "../../hooks/useMobile"
import { useCoachingGroupsQuery } from "../../networking/coachingGroups/queries"
import PaymentFailedHeader from "../../pages/clients/FailedPaymentHeader"
import useMobileViewStore, {
  SendBirdView,
} from "../../pages/home/store/useMobileViewStore"

const ClientPage = () => {
  const { isLoading: isLoadingCoachingGroups } = useCoachingGroupsQuery()
  const { view } = useMobileViewStore()
  const isMobile = useMobile()
  const { currentChannel } = useSendbird()
  useSetCurrentSBChannel()

  if (!currentChannel || isLoadingCoachingGroups) return null
  if (isMobile && view !== SendBirdView.CHANNEL_DETAIL) return null

  return (
    <div className="flex flex-col h-full flex-1">
      <ClientPageHeader />
      <PaymentFailedHeader />
      <TOSNotSignedHeader />
      <Outlet />
      <ScheduledMessageModal />

      <SessionBookingModal />
      <SessionNoShowModal />
      <SessionLateCancelModal />
      <SessionMakeupVerificationModal />
    </div>
  )
}

export default ClientPage
